import React, { useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import '../aboutUs/aboutUs.css';
import { fetchAboutUsData } from "../../redux/Actions/policyActions";

function AboutUs() {

    const dispatch = useDispatch<any>();

    const aboutUsData: any = useSelector<any>(
        (state) => state?.aboutUs
      );

    useEffect(() => {
        dispatch(fetchAboutUsData());
      }, []);

    return (
        <div>
            <div className="breadcrumpset">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                        <div className="breadcrumpview">
                            <h2>{aboutUsData?.title_en}</h2>
                            <ul>
                            <li>
                                <a href="/"><i className="fa fa-home" aria-hidden="true"></i> </a>
                            </li>
                            <li>
                                <span>{aboutUsData?.title_en}</span>
                            </li>
                            </ul>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="service-content-wrapper about-content my-77 theme-clr-primory">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="policy-section">
                            <div dangerouslySetInnerHTML={{__html: aboutUsData?.details_en}} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AboutUs